import { Component, Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { OtSlotsViewComponent } from 'src/modules/kx-shared/components/ot-appointment/ot-slots-view/ot-slots-view.component';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { SearchAndSelect } from 'src/modules/base/components/form/models/serachselect.model';

@Component({
    selector: 'app-ot-surgery-detail',
    templateUrl: './ot-surgery-detail.component.html',
    standalone: false
})
export class OtSurgeryDetailComponent implements OnInit {

  configForm = {
    "submitButton": false,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": ''
  }
  config = {
    "add_required": true,
    "table": true,
    "tile": false
  }
  resourceDef: any;
  patientDetail: any;
  surgeryDetailObj: any = {};
  surgeryForm: any;
  decorator: any;
  response: any;
  sequenceArray = {
    "anesthesia_checkin_date_time": "Anesthesia Start Date & Time",
    "ot_checkin_date_time": "Check-In Date & Time",
    "service_start_time": "Surgery Start Date & Time",
    "service_end_time": "Surgery End Date & Time",
    "ot_checkout_date_time": "Check-Out Date & Time",
    "anesthesia_checkout_date_time": "Anesthesia End Date & Time"
  }
  partialResponse: any;
  resourcename: string;
  resource: any;
  asaGradingMandate: boolean = false;
  action: string;
  finalResource: string;
  additionalSurgeryCheck: boolean = false;
  additionalSurgeryData: any = [];
  additionalSurgeryConfig: boolean = false;
  partialResponseMandatory: any;
  otSlots = {
    additionalSurgeries: [],
    multisurgeryName: [],
    defaultsetting: {
      "singleSelection": true,
      "allowSearchFilter": true,
      "checkBoxRequired": false,
      "closeDropDownOnSelection": true,
      "apliCall": false
    }
  }

  constructor(
    public injector: Injector,
    public baseService: BaseService,
    public alerts: AlertsService,
    public loader: LoaderService,
    public router: Router,
    public route: ActivatedRoute,
    public modal: BsModalService
  ) {
  }

  ngOnInit(): void {
    this.resourcename = this.resource.resource;
    if (this.router.url.indexOf('ot_surgery_details') > -1) {
      if (this.router.url.indexOf('VIEW') > -1) {
        this.action = 'VIEW';
      }
      if (this.router.url.indexOf('DRAFT') > -1) {
        this.action = 'DRAFT';
      }
      if (this.router.url.indexOf('MODIFY') > -1) {
        this.action = 'MODIFY';
      }
      this.finalResource = 'ot_surgery_details';
    }
    else {
      this.action = 'ADD';
      this.finalResource = 'surgery_request';
    }
    this.baseService.getResourceDef(this.resourcename, (data) => {
      this.surgeryDetailObj['surgery_type'] = data.surgeryType
      this.baseService.get("GET_SURGERY_SEQUENCE", "surgeryType:" + data.surgeryType + ",type_:" + data.type_, "surgery_sequence_master", "facility-management", "").subscribe((res: any) => {
        if (res.errCode == 0) {
          this.response = res.resource.sort(function (a, b) { return a.validation_sequence - b.validation_sequence });
          this.partialResponseMandatory = this.response.filter(x => x.facility_required == true)
          this.response = this.response.filter(x => x.id != 'antibiotic_administration_date_time' && x.id != 'incision_date_time')
          this.partialResponse = this.response.filter(x => x.facility_required == true)
          this.resourceDef = data;
          if (this.resourceDef.config != undefined && this.resourceDef.config.decorator != undefined) {
            this.decorator = this.baseService.initDecorator(this.resourceDef.config.decorator, this.route, this.injector);
          }
          for (let s of res.resource) {
            if (data.form.blocks[1].fields.find(x => x.name == s.id) != undefined) {
              data.form.blocks[1].fields.find(x => x.name == s.id)['required'] = s.facility_required;
              data.form.blocks[1].fields.find(x => x.name == s.id)['order'] = s.sequence + 5;
            }
            if (data.form.blocks[2].fields.find(x => x.name == s.id) != undefined) {
              data.form.blocks[2].fields.find(x => x.name == s.id)['required'] = s.facility_required;
            }
          };
        }
      })
      this.baseService.get("GET_CONFIG", "module_code:ot,config_code:OT_270", "facility_config_mapping", "facility-management", "").subscribe(
        res => {
          if (res.errCode == 0) {
            if (res.resource[0].config_value == 'yes') {
              this.asaGradingMandate = true;
              data.form.blocks[2].fields.find(x => x.name == 'asa_grade_id')['required'] = true;
            }
          }
        }
      )
    })
    this.baseService.get("GET_CONFIG", "module_code:ot,config_code:ot_103", "facility_config_mapping", "facility-management", "").subscribe(
      res => {
        if (res.errCode == 0) {
          if (res.resource[0].config_value == 'yes') {
            this.additionalSurgeryConfig = true;
          }
        }
      }
    )
    this.baseService.get("GET_BY_ID", "id:" + this.route.snapshot.queryParams.key, this.finalResource, "ot", "").subscribe((res: any) => {
      if (res.errCode == 0) {
        this.patientDetail = res.resource[0];
        if (this.patientDetail.surgeon_details == undefined) {
          this.patientDetail.surgeon_details = [];
        }
        if (this.patientDetail.mandatory_component != undefined && this.action == 'ADD') {
          for (let i = 0; i < this.patientDetail.mandatory_component.length; i++) {
            if (this.patientDetail.mandatory_component[i].component_type_id == 'ot_managemant') {
              let obj = {
                "id": "",
                "surgery_component_type": "ot_managemant",
                "surgery_billing_component": this.patientDetail.mandatory_component[i].component_name,
                "surgery_billing_component_Id": this.patientDetail.mandatory_component[i].component_name_id,
                "surgery_type": "",
                "surgeon_id": "",
                "care_professional_surgeon_id": "",
                "ot": this.patientDetail.ot_name,
                "ot_id": this.patientDetail.ot_id
              }
              this.patientDetail.surgeon_details.push(obj);
            }
          }
        }
        this.otSlots['question'] = new SearchAndSelect({
          label: "",
          datasource: {
            "query_id": "GET_SCHEDULED_SURGERIES",
            "args": "surgery_type:" + this.patientDetail['surgery_type'] + ",id:" + this.patientDetail.id,
            "application": "ot",
            "filter": "request_type:" + this.patientDetail.request_type + ",uhId:" + this.patientDetail.uhId,
            "default_args": "surgery_type:OT",
            "resource": "surgery_request"
          },
          defaultsetting: this.otSlots['defaultsetting'],
          order: 1,
          getterKey: 'id',
          getterValue: 'serviceItemName',
          options: false,
        });
        if (this.patientDetail['art_type'] && this.patientDetail['art_ot_details']) {
          this.patientDetail['no_of_oocytes_retrieved'] = this.patientDetail['art_ot_details']['no_of_oocytes_retrieved']
          this.patientDetail['no_of_embryos_transferred'] = this.patientDetail['art_ot_details']['no_of_embryos_transferred']
        }
        this.baseService.get("GET_SCHEDULED_SURGERIES", "surgery_type:" + this.patientDetail['surgery_type'] + ",id:" + this.patientDetail.id, 'surgery_request', "ot", "request_type:" + this.patientDetail.request_type + ",uhId:" + this.patientDetail.uhId).subscribe((res: any) => {
          if (res.errCode == 0 && res.resource) {
            this.otSlots.multisurgeryName = res.resource;
          }
        })
      }
    })
    this.surgeryDetailObj['data'] = [];
  }

  onItemDeSelect(item: any) {
    this.otSlots.additionalSurgeries = item
  }

  onItemSelect(surgeryId) {
    this.otSlots.additionalSurgeries.push(surgeryId)
  }

  questionValueChanged(event: any) {
    this.surgeryForm = event.form;
    this.surgeryDetailObj = event.form.value;
  }

  // surgery_notes is a disabled checkbox, so form.value drops it; backend needs it to push completed surgery to billing
  getSurgeryNotes(fallback: any) {
    let surgeryNotes = this.surgeryForm?.getRawValue ? this.surgeryForm.getRawValue()['surgery_notes'] : undefined;
    if (surgeryNotes === undefined || surgeryNotes === null || surgeryNotes === '') {
      surgeryNotes = fallback;
    }
    return surgeryNotes == true || surgeryNotes == 'true';
  }

  additionalSurgery(event, isChecked: boolean) {
    this.additionalSurgeryCheck = isChecked;
    console.log(this.additionalSurgeryData)
    if (isChecked) {
      let data: any
      data = { showSurgery: true, surgeryDetail: this.surgeryDetailObj, additionalSurgeryData: this.additionalSurgeryData }
      this.baseService.modalService.dialogService.open(OtSlotsViewComponent, { data: data, size: DialogModalSize.Lg }).afterClosed.subscribe((res: any) => {
        if (res) {
          this.additionalSurgeryData = res;
        }
        if (res == undefined) {
          this.additionalSurgeryData = [];
          this.additionalSurgeryCheck = false;
        }
      })
    }
  }

  saveData(stage: any) {
    if (this.surgeryDetailObj.equipment_details != undefined && this.surgeryDetailObj.equipment_details.length != 0) {
      let participant = [
        {
          "participantRole": "doctor",
          "participantId": this.surgeryDetailObj.surgeon_id,
          "participantName": this.surgeryDetailObj.surgeon,
          "action": "ORDERING"
        }
      ]
      for (let i = 0; i < this.surgeryDetailObj.equipment_details.length; i++) {
        this.surgeryDetailObj.equipment_details[i]['participant'] = participant;
        if (this.surgeryDetailObj.equipment_details[i].serviceStartTime == undefined || this.surgeryDetailObj.equipment_details[i].serviceStartTime == "") {
          delete this.surgeryDetailObj.equipment_details[i].serviceStartTime
        }
        if (this.surgeryDetailObj.equipment_details[i].serviceEndTime == undefined || this.surgeryDetailObj.equipment_details[i].serviceEndTime == "") {
          delete this.surgeryDetailObj.equipment_details[i].serviceEndTime
        }
        if (this.surgeryDetailObj.equipment_details[i].serviceDate == undefined || this.surgeryDetailObj.equipment_details[i].serviceDate == "") {
          delete this.surgeryDetailObj.equipment_details[i].serviceDate
        }
        if (this.surgeryDetailObj.equipment_details[i].serviceStartTime < this.surgeryDetailObj.service_start_time || this.surgeryDetailObj.equipment_details[i].serviceStartTime > this.surgeryDetailObj.service_end_time) {
          this.alerts.error("Please Select Machine Start Time Between Surgery Start And End Time");
          return;
        }
        if (this.surgeryDetailObj.equipment_details[i].serviceEndTime < this.surgeryDetailObj.service_start_time || this.surgeryDetailObj.equipment_details[i].serviceEndTime > this.surgeryDetailObj.service_end_time) {
          this.alerts.error("Please Select Machine End Time Between Surgery Start And End Time");
          return;
        }
      }
      var patient = {
        "patient_details": {
          "patient_id": this.surgeryDetailObj.patient_id,
          "uhId": this.surgeryDetailObj.uhId,
          "admissionId": this.surgeryDetailObj.encounter_id,
          "encounter_id": this.surgeryDetailObj.encounter_id,
          "patientType": this.surgeryDetailObj.patientType,
        },
        "services": this.surgeryDetailObj.equipment_details
      }
      this.surgeryDetailObj['service_request_handler'] = patient;
      delete this.surgeryDetailObj.equipment_details;
    }
    this.surgeryDetailObj.service_start = this.surgeryDetailObj.service_start_time;
    this.surgeryDetailObj.surgery_request_id = this.surgeryDetailObj.id;
    this.surgeryDetailObj.requested_surgery_date_time = this.patientDetail.g_creation_time;
    if (this.surgeryDetailObj.asa_grade_id == '') {
      delete this.surgeryDetailObj.asa_grade_percentage;
    }
    if (this.surgeryDetailObj.service_date == '') {
      this.surgeryDetailObj.service_date = new Date().getTime();
    }
    if (this.surgeryDetailObj.surgeon_details.length == 0) {
      this.alerts.error("Add Surgeon Details", "Add Surgeon Details")
      return;
    }
    if (this.surgeryDetailObj.antibiotic_name.length > 250) {
      this.alerts.error("Lenght for antibiotic_name should not be greater than 250")
      return;
    }
    if (this.surgeryDetailObj.surgeon_details.length != 0) {
      let num: any;
      for (let i = 0; i < this.surgeryDetailObj.surgeon_details.length; i++) {
        if (this.surgeryDetailObj.surgeon_details[i].is_surgeon == true) {
          num = 1;
          break;
        }
        else
          num = 0;
      }
      if (num == 0) {
        this.alerts.error("Please Select Main Surgeon");
        return;
      }
    }
    if (this.patientDetail.serviceType_code == 'surgery' && this.surgeryDetailObj.surgery_category_id == '') {
      this.alerts.error("Please Fill Surgery Category");
      return;
    }
    if (this.surgeryDetailObj.priority_id == '') {
      this.alerts.error("Please Fill Priority");
      return;
    }
    if (this.surgeryDetailObj.ot_id == '') {
      this.alerts.error("Please Fill " + this.surgeryDetailObj.surgery_type);
      return;
    }
    if (this.surgeryDetailObj.asa_grade_id == '' && this.asaGradingMandate == true) {
      this.alerts.error("Please Select ASA Grading");
      return;
    }
    for (let i = 0; i < this.partialResponseMandatory.length; i++) {
      if (this.surgeryDetailObj[this.partialResponseMandatory[i]['id']] == null) {
        this.alerts.error("Please Fill All Required Fields");
        return;
      }
    }
    for (let i = 0; i < this.response.length - 1; i++) {
      if (this.surgeryDetailObj[this.response[i]['id']] != null && this.surgeryDetailObj[this.response[i + 1]['id']] != null) {
        if (this.surgeryDetailObj[this.response[i]['id']] > this.surgeryDetailObj[this.response[i + 1]['id']] || this.surgeryDetailObj[this.response[i]['id']] == this.surgeryDetailObj[this.response[i + 1]['id']]) {
          this.alerts.error(this.sequenceArray[this.response[i]['id']] + " should before than " + this.sequenceArray[this.response[i + 1]['id']])
          return;
        }
      }
      if (this.partialResponse[i] != undefined && this.surgeryDetailObj[this.partialResponse[i]['id']] != null && this.partialResponse[i + 1] != undefined && this.surgeryDetailObj[this.partialResponse[i + 1]['id']] != null) {
        if (this.surgeryDetailObj[this.partialResponse[i]['id']] > this.surgeryDetailObj[this.partialResponse[i + 1]['id']] || this.surgeryDetailObj[this.partialResponse[i]['id']] == this.surgeryDetailObj[this.partialResponse[i + 1]['id']]) {
          this.alerts.error(this.sequenceArray[this.partialResponse[i]['id']] + " should before than " + this.sequenceArray[this.partialResponse[i + 1]['id']])
          return;
        }
      }
    };
    if (this.surgeryDetailObj[this.partialResponse[0]['id']] != null && this.surgeryDetailObj[this.partialResponse[0]['id']] < this.surgeryDetailObj.admission_date_time) {
      this.alerts.error(this.sequenceArray[this.partialResponse[0]['id']] + " should after than Admission Date and Time");
      return;
    }
    if (this.surgeryDetailObj['antibiotic_administration_date_time'] != null && (this.surgeryDetailObj['admission_date_time'] > this.surgeryDetailObj['antibiotic_administration_date_time'] || this.surgeryDetailObj['service_end_time'] < this.surgeryDetailObj['antibiotic_administration_date_time'] || this.surgeryDetailObj['admission_date_time'] == this.surgeryDetailObj['antibiotic_administration_date_time'] || this.surgeryDetailObj['service_end_time'] == this.surgeryDetailObj['antibiotic_administration_date_time'])) {
      this.alerts.error("Antibiotic Administration Date Time should after than Admission Date & Time and before than Surgery End Date & Time");
      return;
    }
    if (this.surgeryDetailObj['incision_date_time'] != null && (this.surgeryDetailObj['service_start_time'] > this.surgeryDetailObj['incision_date_time'] || this.surgeryDetailObj['service_end_time'] < this.surgeryDetailObj['incision_date_time'] || this.surgeryDetailObj['service_start_time'] == this.surgeryDetailObj['incision_date_time'] || this.surgeryDetailObj['service_end_time'] == this.surgeryDetailObj['incision_date_time'])) {
      this.alerts.error("Incision Date Time should after than Surgery Start Date & Time and before than Surgery End Date & Time");
      return;
    }
    this.loader.showSpinner();
    if (this.surgeryDetailObj.patientType == 'OP') {
      this.surgeryDetailObj.admission_date_time = 0;
    }
    if (this.surgeryDetailObj.patient_age_in_milli == '') {
      delete this.surgeryDetailObj.patient_age_in_milli
    }
    if (!this.surgeryDetailObj.anesthesia_type) {
      this.surgeryDetailObj.anesthesia = "";
    }
    if (!this.surgeryDetailObj.anesthesia_subtype_id) {
      this.surgeryDetailObj.anesthesia_subtype = "";
    }
    if (!this.surgeryDetailObj.asa_grade_id) {
      this.surgeryDetailObj.asa_grade_name = "";
      this.surgeryDetailObj.asa_grade_percentage = "";
    }

    let action = '';
    if (this.action == 'DRAFT') {
      if (stage == 'draft') {
        action = 'DRAFT_SURGERY_DETAILS';
        this.surgeryDetailObj['stage'] = 'Draft';
        this.surgeryDetailObj['status'] = 'Pending';
        this.surgeryDetailObj['id'] = this.patientDetail.id;
      }
      if (stage == 'final') {
        action = '';
      }
      this.surgeryDetailObj['draft_id'] = this.patientDetail.id;
      this.surgeryDetailObj['surgery_request_id'] = this.patientDetail.surgery_request_id;
    }
    if (this.action == 'ADD') {
      if (stage == 'draft') {
        action = 'DRAFT_SURGERY_DETAILS';
        this.surgeryDetailObj['stage'] = 'Draft';
        this.surgeryDetailObj['status'] = 'Pending';
      }
      if (stage == 'final') {
        action = '';
      }
      this.surgeryDetailObj['surgery_request_id'] = this.patientDetail.id;
    }
    if (this.action == 'MODIFY') {
      action = 'MODIFY';
      this.surgeryDetailObj['id'] = this.patientDetail.id;
      this.surgeryDetailObj['surgery_request_id'] = this.patientDetail.surgery_request_id;
    }
    this.surgeryDetailObj['surgery_notes'] = this.getSurgeryNotes(this.patientDetail.surgery_notes);
    this.surgeryDetailObj['data'] = this.additionalSurgeryCheck ? this.additionalSurgeryData : [];
    this.surgeryDetailObj['is_additional_surgery'] = this.additionalSurgeryCheck
    if (this.surgeryDetailObj['mandatory_component'] == "") {
      delete this.surgeryDetailObj['mandatory_component'];
    }
    if (this.surgeryDetailObj['art_type']) {
      this.surgeryDetailObj['art_ot_details'] = {
        'no_of_oocytes_retrieved': this.surgeryDetailObj['no_of_oocytes_retrieved'],
        'no_of_embryos_transferred': this.surgeryDetailObj['no_of_embryos_transferred'],
      }
      delete this.surgeryDetailObj['no_of_oocytes_retrieved'];
      delete this.surgeryDetailObj['no_of_embryos_transferred'];
    }
    if (this.surgeryDetailObj && this.surgeryDetailObj.surgeon_details && this.surgeryDetailObj.surgeon_details.length > 0) {
      this.surgeryDetailObj.surgeon_details.forEach(element => {
        if (element.standard_codes == "" || element.standard_codes == undefined) {
          element.standard_codes = []
        }
      });
    }
    if (this.otSlots.additionalSurgeries && this.otSlots.additionalSurgeries.length > 0) {
      this.surgeryDetailObj['data'] = []
      this.surgeryDetailObj['multiple_surgery_detailing'] = true
      for (let i = 0; i < this.otSlots.additionalSurgeries.length; i++) {
        let surgery = this.otSlots.multisurgeryName.find(val => val.id == this.otSlots.additionalSurgeries[i].id)
        const obj = { ...this.surgeryDetailObj }
        obj['surgery_request_id'] = surgery['id']
        obj['serviceItemId'] = surgery['serviceItemId']
        obj['serviceItemCode'] = surgery['serviceItemCode']
        obj['serviceItemName'] = surgery['serviceItemName']
        obj['surgery_category_id'] = surgery['surgery_category_id']
        obj['service_request_id'] = surgery['service_request_id']
        obj['surgery_code'] = surgery['surgery_code']
        obj['surgery_code_id'] = surgery['surgery_code_id']
        obj['service_order_id'] = surgery['service_order_id']
        if (surgery['surgery_notes'] !== undefined && surgery['surgery_notes'] !== null) {
          obj['surgery_notes'] = surgery['surgery_notes'] == true || surgery['surgery_notes'] == 'true'
        }
        delete obj['data']
        this.surgeryDetailObj['data'].push(obj)
      }
    }

    this.surgeryDetailObj.surgeon_details = [...new Set(this.surgeryDetailObj.surgeon_details)];
    this.baseService.action(this.surgeryDetailObj, action, 'ot', this.resourceDef.form.APIresource.datasource.resource).subscribe((result) => {
      if (result.message.toLowerCase() == "success") {
        this.loader.hideSpinner();
        this.alerts.success(result.message)
        this.baseService.router.navigateByUrl(this.route.snapshot.queryParams.returnUrl)
      } else {
        // if(this.surgeryDetailObj.surgeon_details != undefined){
        //   for (let i = 0; i < this.surgeryDetailObj.surgeon_details.length; i++) {
        //     if(this.surgeryDetailObj.surgeon_details[i].surgery_component_type == 'anaesthetist'){
        //       this.surgeryDetailObj.surgeon_details.splice(i,1);
        //       i=i-1;
        //     }
        //   }
        // }
        this.loader.hideSpinner()
        this.alerts.error(result.message)
      }
      (err) => {
        this.loader.hideSpinner()
        console.error("error in getting data :: ", err)
      }
    })
  }

}
